module.exports = __webpack_public_path__ + "static/media/blog-card-image.cac12271.png";